import $ from 'jquery';

export function successPopup() {
    const closePopup = $('.popup__close-success');
    const bodyOveflow = $('body');
    
    closePopup.on('click', function(){
        const clickParent = this.closest('.popup-thx');

        if($(clickParent).hasClass('active')) {
            $(clickParent).removeClass('active');
            bodyOveflow.removeClass('overflow-thx');
        }
    })
}


// WEBPACK FOOTER //
// app/scripts/components/success.js